


















































































import Vue from 'vue';
import { mixin as clickaway } from 'vue-clickaway';
import axios from 'axios';
import store from '../../store';
import { Hit } from '@/types/hit';
import { SpecialKeys } from '@/types/keys';
import Component from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import { mapGetters } from "vuex";
import VueTopicDecorator from './decorators/topic.vue';
import VueJobDecorator from './decorators/job';
import VueMicroblogDecorator from './decorators/microblog';
import VueWikiDecorator from './decorators/wiki';
import VueUserDecorator from './decorators/user.vue';
import { HitCategory, Contexts, Models } from '@/types/search';

// @ts-ignore
@Component({
  mixins: [ clickaway ],
  store,
  computed: mapGetters('user', ['isAuthorized']),
  components: {
    'vue-topic-decorator': VueTopicDecorator,
    'vue-job-decorator': VueJobDecorator,
    'vue-wiki-decorator': VueWikiDecorator,
    'vue-microblog-decorator': VueMicroblogDecorator,
    'vue-user-decorator': VueUserDecorator
  }
})
export default class VueSearchbar extends Vue {
  isActive: boolean = false;
  isDropdownVisible: boolean = false;
  isHelpEnabled: boolean = false;
  isMobile: boolean = false;
  items: Hit[] = [];
  selectedIndex: number = -1;
  params?: URLSearchParams;

  readonly isAuthorized! : boolean;

  @Prop()
  value!: string;

  @Ref('input')
  readonly input!: HTMLInputElement;

  @Watch('value')
  resetItems(val: string) {
    if (val === '') {
      this.items = [];
    }
  }

  created() {
    this.makeParams();
  }

  mounted() {
    document.addEventListener('keydown', this.shortcutSupport);

    // @ts-ignore
    history.onpushstate = window.onpopstate = () => {
      // wait for location to really change before setting up new url
      setTimeout(() => this.makeParams(), 0);
    }
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.shortcutSupport);
  }

  toggleMobile() {
    this.isMobile = ! this.isMobile;

    if (this.isMobile) {
      this.$nextTick(() => (this.$refs.input as HTMLInputElement).focus());
    }
  }

  showDropdown() {
    this.isActive = true;
    this.isDropdownVisible = true;

    // show basic set of links for given user even if no query was provided
    this.loadItems();
  }

  hideDropdown() {
    if (this.isDropdownVisible) {
      this.isDropdownVisible = false;
    }
    else {
      this.value = '';
    }
  }

  blurInput() {
    this.isActive = false;
  }

  clearInput() {
    this.value = '';
    this.loadItems();
  }

  down() {
    this.isDropdownVisible = true;

    this.changeIndex(++this.selectedIndex);
  }

  up() {
    this.changeIndex(--this.selectedIndex);
  }

  hoverItem(index) {
    this.selectedIndex = index;
  }

  changeIndex(index) {
    const length = this.items.length;

    if (length > 0) {
      if (index >= length) {
        index = 0;
      }
      else if (index < 0) {
        index = length - 1;
      }

      this.selectedIndex = index;
    }
  }

  categoryLabel(category: Hit): string {
    return category.context !== undefined ? Contexts[category.model][category.context] : Models[category.model];
  }

  completion(event: KeyboardEvent): void {
    this.isHelpEnabled = this.value === '?';

    if (this.isHelpEnabled || Object.values(SpecialKeys).includes(event.keyCode)) {
      return;
    }

    this.selectedIndex = -1; // reset position index after key pressed
    this.loadItems();
  }

  loadItems(): void {
    const headers = this.isAuthorized ? {Authorization: `Bearer ${this.$store.state.user.user.token}`} : {};

    if (!this.endpoint) {
      return;
    }

    axios.get(this.endpoint, {params: {q: this.value || null}, headers}).then(response => {
      this.items = response.data;
      this.isDropdownVisible = true;
    });
  }

  shortcutSupport(event: KeyboardEvent): void {
    if (event.key === '?' && event.shiftKey && this.elementSupportSearchShortcut(event)) {
      event.preventDefault();

      (this.$refs.input as HTMLInputElement).focus();
    }
  }

  private elementSupportSearchShortcut(event: KeyboardEvent) {
    const htmlElement = event.target as HTMLElement;
    if (htmlElement.isContentEditable) {
      return !htmlElement.closest(".editor-4play"); // make sure we found 4play editor
    }
    return !/^(?:input|textarea|select|button)$/i.test(htmlElement.tagName);
  }

  changeUrl(): void {
    if (this.selectedIndex === -1) {
      (this.$refs.search as HTMLFormElement).submit();

      return;
    }

    window.location.href = this.items.find(item => item.index === this.selectedIndex)!.url;
  }

  makeParams(): void {
    if (window.location.pathname !== '/Search') {
      this.params = undefined;

      return;
    }

    const params = new URLSearchParams(window.location.search);
    params.delete('q');
    params.delete('page');

    this.params = params;
  }

  makeDecorator(item: Hit): string {
    return `vue-${item.model.toLowerCase()}-decorator`;
  }

  get endpoint(): string | null {
    return this.value.trim() === '' ? (this.isAuthorized ? '/completion/hub/' : null) : '/completion/';
  }

  get categories() {
    let counter = 0;
    let result: HitCategory = {};

    this.items.forEach(item => {
      const key = `${item.model}-${item.context}`;
      let model, context;

      ({model, context} = item);

      if (!result[key]) {
        result[key] = {children: [], model, context}
      }

      result[key].children.push(item);
    });

    return Object.values(result).map(category => {
      category.children.forEach(child => Object.assign(child, {index: counter++}));

      return category;
    });
  }
}
